module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "intro"
    }
  }, [_c('img', {
    staticClass: "middle",
    attrs: {
      "alt": "Image",
      "src": "images/chap.jpg"
    }
  }), _c('strong', [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Leadership is the cornerstone of all great organizations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yes, before you think it, I do understand that more is required than outstanding leadership to build an enduring organization. After a five-year research effort, our team found High Performance Organizations actually have "), _c('em', [_vm._v("four things")]), _vm._v(" in common. They all Bet on Leadership, Act as One, Win the Heart, and Excel at Execution. I wrote about these “moves” in my previous book, "), _c('em', [_vm._v("Chess Not Checkers.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, the journey to high performance always begins with leadership. This book is a deep dive on one critical question every organization faces:")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_c('strong', [_vm._v("How do you ensure you’ll have the needed leaders to fuel your future success?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The answer, in short: Build a leadership culture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let’s be clear on terms from the beginning. A leadership culture exists when leaders are routinely and systematically developed, "), _c('em', [_vm._v("and")]), _vm._v(" you have a surplus of leaders ready for the next opportunity or challenge."), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Imagine what would happen if organizations were proactive and strategic and built their own leadership pipeline and filled their bench with capable, ready-now leaders? What if companies and nonprofits created a culture in which exceptional leadership at all levels was the norm?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even as I write this, I am well aware of the resistance to this idea of building a leadership culture. Here are some of the more common objections. . . .")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("“We don’t need a leadership culture; we’re doing fine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You may be right: you are doing fine—for now. However, even in organizations currently enjoying success, this is often due to the efforts of a few good women and men who shoulder the burden for their entire organization. Their heroic acts are required again and again to win the day. Not only does this approach fail to leverage the full capacity of your people, but sustained greatness is unlikely.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("“Leaders are born, not made.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you fall victim to this myth, your organization is probably not going to make the investments needed to grow leaders at all levels. You will just wait for the next leader to walk through the door. In essence, you are waiting for Superman or Superwoman to miraculously appear and save your company. This is a dubious strategy for future success. "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("“We’re too busy to think about the future.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If your organization is like most, you probably do not have enough capable leaders in place today. And, if you have a shortage of leaders, the ones you do have are often pedaling hard just trying to keep up. They certainly aren’t thinking about developing future leaders. Therefore, a leadership shortfall today is often the preamble to a shortage of future leaders. If you do not break this cycle, it may ultimately break you.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('em', [_vm._v("“Even if we wanted a leadership culture, we don’t know how to build one.”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is the best form of resistance! Although I will work to address all the objections outlined above, "), _c('em', [_vm._v("Leaders Made Here")]), _vm._v(" was written primarily for this final group—those who can see the value in a strong bench of capable leaders but just lack the strategic framework to make it so. This book is really for you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ultimately, your future success depends on the "), _c('em', [_vm._v("quantity")]), _vm._v(" and "), _c('em', [_vm._v("quality")]), _vm._v(" of leaders on your team. Follow the path outlined in the following pages, and you will position your organization among the elite. You will create a place where leadership excellence is not a dream but rather a by-product of a sound strategy executed with diligence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The future begins today. Let’s get started!"), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6924e83b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 78
// module chunks = 0